module.exports = __webpack_public_path__ + "static/media/icon_logo.177cd4bf.png";